import React from 'react'
import Page from 'src/templates/Page'

const Home = () => (
  <Page>
    <h1>Welcome to TeyvatGuide website 🎉</h1>
    This website is still under construction and there is a lot of things to do before I'm going to share it publicly
    even if the website is available right now.
    <br />
    Tons of fan made website or even youtube videos are available out there that cover a lot of subject: daily artifacts
    farming, chests route, ore farming etc.
    <br />
    <br />
    The purpose of TeyvatGuide are:
    <ul className="list-disc list-inside">
      <li>Be international which means having guides in multiple language (WIP)</li>
      <li>Not having too watch a full youtube video to see the overview of a guide / articles will looks like</li>
      <li>Have guides to be up to date when a patch has been released if it has an impact on the guide (WIP)</li>
      <li>Have guides / articles to be as simple as possible, short enough and be easy to read</li>
      <li>Cover guides that has not been covered yet (as far as I know)</li>
      <li>Be open source in the mid-long-term when the code is clean enough</li>
    </ul>
    <br />
    I'm working alone on this project at the moment, any volonteer are welcomed to join me to make this website grow !
    I'm looking for:
    <ul className="list-disc list-inside">
      <li>Programmer </li>
      <li>Designer</li>
      <li>Guides / Articles writter</li>
    </ul>
    <br />
    Feel free to reach me on discord <strong>Riceflake#9638</strong> if you want to have more details or have any
    suggestions for the website !
    <br />
    If you're curious about what I planned as future projects on TeyvatGuide feel free to take a look at{' '}
    <a href="/about">the roadmap here</a>
  </Page>
)

export default Home
